import {
  ListMarketplaceListings,
  ListMarketplaceListingsVariables,
  ListMarketplaceListings_listMarketplaceListings_marketplaceListings
} from './__generated__/ListMarketplaceListings'
import { MarketplaceListingSortBy, MarketplaceListingSortOrder } from '../types'

import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query ListMarketplaceListings($input: MarketplaceListingInput!) {
    listMarketplaceListings(input: $input) {
      marketplaceListings {
        id
        title
        created
        developerId
        developerName
        description
        shortDescription
        categoryIds
        deleted
        releaseDate
        installableId
        installableTitle
        installableCreated
        messageSetId
        messageSetTitle
        installationsCount
        subscriptionsCount
        enabledSubscriptionsCount
        subscriptionsInPast30DaysCount
        subscriptionsInPast7DaysCount
        featureTypes
        supportsNote
        supportsFlagship
        icon
        listing {
          icon
          noteMessageSetId
          stagingOnly
          version
          free
          isSingleton
          questionAndAnswerId
          noteQuestionAndAnswerId
          previewMessage
          notePreviewMessage
          readyForReactNative
          configuration
        }
      }
      pagination {
        page
        perPage
        total
      }
    }
  }
`

interface IUseListMarketplaceListings {
  page?: number
  perPage?: number
  sortBy?: MarketplaceListingSortBy
  sortOrder?: MarketplaceListingSortOrder
}

export const useListMarketplaceListings = (input: IUseListMarketplaceListings) => {
  return useQuery<ListMarketplaceListings, ListMarketplaceListingsVariables>(QUERY, {
    variables: {
      input
    },
    fetchPolicy: 'network-only'
  })
}

useListMarketplaceListings.query = QUERY

export type MarketplaceListing = ListMarketplaceListings_listMarketplaceListings_marketplaceListings
